import { Container } from "react-bootstrap";
import "./AboutSpirulina.css";
import WhiteButton from "./../../common_components/common_button/WhiteButton";
import { useNavigate } from 'react-router-dom';

export default function AboutSpirulina() {

   const navigate = useNavigate();

  return (
    <section className="about-spirulina">
      <video autoPlay loop muted playsInline className="about-spirulina-video">
        <source src="/videos/home/aboutSpirulina.mp4" type="video/mp4" />
      </video>

      {/* Overlay */}
      <div className="about-spirulina-overlay"></div>

      <Container>
        <div className="about-spirulina-content">
          <h2>
            About <span>Spirulina</span>
          </h2>

          <p>
            we are dedicated to bringing the pure power of Spirulina to your
            life. As a trusted health and wellness brand, we focus on quality,
            sustainability, and natural nutrition. Our Spirulina products are
            rich in nutrients, ethically sourced, and crafted to support energy,
            immunity, and overall well-being.
          </p>

          <p>
            We believe in healthy living for everyone & aim to empower
            individuals through conscious choices & a community driven growth
            opportunity. Grow healthier naturally.
          </p>

          <WhiteButton
            title={"Know More"}
            bg="#ffff"
            color="#000"
            hoverColor="#f35f37"
            hoverBg={"#000"}
             onClick={() => navigate("/about")}
          />
        </div>
      </Container>
    </section>
  );
}
